import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import { isSmallViewport } from '../../platformui/Hooks/useMedia';
import SupportPlaceBlock from '../c-support-place-block';
import SupportPlaceCategories from './categories';
import SupportPlaceFilters from './filters/index';

const SupportPlaceFilterBlock = (props) => {
  const {
    CategoryLabel,
    FilterCategories,
    FilterLabel,
    Filters,
    ShowAllSelected,
    SupportPlaceContent,
    ShowAllCategoriesButtonText,
    ShowAllFiltersButtonText,
  } = props;

  const [selectedCategory, setSelectedCategory] = useState({
    key: 'showAll',
    value: undefined,
  });
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [isAscending, setIsAscending] = useState(true);
  const isMobile = isSmallViewport();

  const toggleSortOrder = () =>
    setIsAscending((prevIsAscending) => !prevIsAscending);

  const resetFilters = () => {
    setSelectedFilters([]);
  };

  const sortByName = (a, b) =>
    isAscending ? a.Name?.localeCompare(b.Name) : b.Name?.localeCompare(a.Name);

  const filterByCategory = (supportPlace) =>
    selectedCategory.key === 'showAll'
      ? true
      : supportPlace.ActiveCategories &&
        Object.keys(supportPlace.ActiveCategories).includes(
          selectedCategory.key
        );

  const filterBySelectedFilters = (supportPlace) =>
    selectedFilters.length === 0 ||
    (supportPlace.ActiveFilters &&
      selectedFilters.every((selectedFilter) =>
        supportPlace.ActiveFilters.some(
          (filter) => selectedFilter.Id === filter.Id
        )
      ));

  const handleFilterChange = (filter) => {
    setSelectedFilters((prevSelectedFilters) => {
      const isSelected = prevSelectedFilters.some(
        (selectedFilter) => selectedFilter.Id === filter.Id
      );

      const updatedFilters = isSelected
        ? prevSelectedFilters.filter(
            (selectedFilter) => selectedFilter.Id !== filter.Id
          )
        : [...prevSelectedFilters, filter];

      return updatedFilters;
    });
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const filteredSupportPlaces = useMemo(() => {
    if (!SupportPlaceContent) return [];

    return [...SupportPlaceContent]
      .filter(filterByCategory)
      .filter(filterBySelectedFilters)
      .sort(sortByName);
  }, [SupportPlaceContent, selectedCategory, selectedFilters, isAscending]);

  if (!SupportPlaceContent || !Filters || !FilterCategories) return;

  return (
    <section className="section">
      <div className="row">
        <div className="columns">
          <div className="c-support-place">
            <SupportPlaceCategories
              isMobile={isMobile}
              label={CategoryLabel}
              list={FilterCategories}
              selectedCategory={selectedCategory}
              onCategoryChange={handleCategoryChange}
              showAllButtonText={ShowAllCategoriesButtonText}
            />

            <SupportPlaceFilters
              isMobile={isMobile}
              label={FilterLabel}
              list={Filters}
              selectedFilters={selectedFilters}
              onFilterChange={handleFilterChange}
              resetFilters={resetFilters}
              showAllButtonText={ShowAllFiltersButtonText}
            />

            {SupportPlaceContent && (
              <div className="c-support-place__list-container">
                <div className="c-support-place__list-container__top-content">
                  <span>
                    <h2 className="filter-info">
                      {selectedCategory.key === 'showAll'
                        ? ShowAllSelected
                        : `Här kan du prata om "${selectedCategory.value}" `}
                    </h2>
                    <p className="filter-info" aria-live="polite">
                      <b>{filteredSupportPlaces.length}</b> träffar
                    </p>
                  </span>
                  <div className="sort-options">
                    <p className="sort-options__sort-text">Sortera efter</p>
                    <button
                      aria-label={`Sortera efter bokstavsordning ${
                        isAscending ? 'A-Ö' : 'Ö-A'
                      }`}
                      className={classNames('sort-options__sort-button', {
                        ascending: isAscending,
                      })}
                      onClick={toggleSortOrder}
                    >
                      {isAscending
                        ? 'Bokstavsordning A-Ö'
                        : 'Bokstavsordning Ö-A'}
                    </button>
                  </div>
                </div>
                {filteredSupportPlaces.map((supportPlace, i) => (
                  <SupportPlaceBlock
                    isFirstItem={i === 0}
                    key={i}
                    {...props}
                    {...supportPlace}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportPlaceFilterBlock;
